import { createFileRoute } from '@tanstack/react-router'
import { MatchesPage, type MatchesSearch } from '~/features/matches/MatchesPage'
import { leagueMatchesQuery, loaderScope, ownMatchesQuery } from '~/features/matches/queries'

export const Route = createFileRoute('/_app/spiele/')({
  validateSearch: (s: Record<string, unknown>): MatchesSearch => ({
    ...(s.ansicht === 'liga' ? { ansicht: 'liga' as const } : {}),
    ...(Number.isInteger(Number(s.spieltag)) && Number(s.spieltag) > 0 ? { spieltag: Number(s.spieltag) } : {}),
    ...(s.ort === 'heim' || s.ort === 'auswaerts' ? { ort: s.ort } : {}),
    ...(typeof s.begegnung === 'string' && /^[0-9a-f-]{36}$/i.test(s.begegnung) ? { begegnung: s.begegnung } : {}),
  }),
  loaderDeps: ({ search }) => ({ league: search.ansicht === 'liga' }),
  loader: async ({ context, deps }) => {
    const scope = await loaderScope(context.queryClient)
    if (!scope?.teamId || !scope.permissions.includes('matches.read')) return
    if (deps.league) await context.queryClient.ensureQueryData(leagueMatchesQuery(scope.teamId, scope.season))
    else await context.queryClient.ensureQueryData(ownMatchesQuery(scope.teamId, scope.season))
  },
  component: function Spiele() {
    return <MatchesPage search={Route.useSearch()} />
  },
})
